import {hasRole} from '../../utils/hasRole';
import React, {useState, useEffect, useRef} from 'react';
import {financePermissions} from '../../utils/financePermissions';
import {proformaNumericValue, canUseProformaPercentage} from '../../utils/projectProforma';
import {useHistory, useParams, useLocation} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import {TabView, TabPanel} from 'primereact/tabview';
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {SplitButton} from "primereact/splitbutton";
import axios from "axios";
import download from "js-file-download";
import {InputSwitch} from "primereact/inputswitch";
import {Calendar} from "primereact/calendar";
import moment from "moment";
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';

import ProjectListComponent from "../../components/2.1/project/ProjectListComponent";
import WorksheetFormComponent from "../../components/2.0/worksheet/WorksheetFormComponent"; // TMP 2.0
import PartnerListComponent from "../../components/2.1/partner/PartnerListComponent";
import PartnerFormComponent from "../../components/2.1/partner/PartnerFormComponent";
import FulfilmentListComponent from "../../components/2.1/project/fulfilment/FulfilmentListComponent";
import FulfilmentFormComponent from "../../components/2.1/project/fulfilment/FulfilmentFormComponent";
import MilestoneListComponent from "../../components/2.1/project/milestone/MilestoneListComponent";
import MilestoneFormComponent from "../../components/2.1/project/milestone/MilestoneFormComponent";
import ProjectShowComponent from "../../components/2.1/project/ProjectShowComponent";
import DocsListComponent from "../../components/2.1/docs/DocsListComponent";
import ProjecttypeListComponent from "../../components/2.1/project/projecttype/ProjecttypeListComponent";
import ProjecttypeFormComponent from "../../components/2.1/project/projecttype/ProjecttypeFormComponent";
import OfferListComponent from "../../components/2.1/project/offer/OfferListComponent";
import OfferFormComponent from "../../components/2.1/project/offer/OfferFormComponent";
import ProjectFormComponent from "../../components/2.1/project/ProjectFormComponent";
import OfferitemListComponent from "../../components/2.1/project/offeritem/OfferitemListComponent";
import OfferitemFormComponent from "../../components/2.1/project/offeritem/OfferitemFormComponent";
import ProjectitemListComponent from "../../components/2.1/project/projectitem/ProjectitemListComponent";
import ProjectstatusListComponent from "../../components/2.1/project/projectstatus/ProjectstatusListComponent";
import ProjectstatusFormComponent from "../../components/2.1/project/projectstatus/ProjectstatusFormComponent";
// import ProjectitemstatusListComponent from "../../components/2.0/projectitemstatus/ProjectitemstatusListComponent";
// import ProjectitemstatusFormComponent from "../../components/2.0/projectitemstatus/ProjectitemstatusFormComponent";
import DocsFormComponent from "../../components/2.1/docs/DocsFormComponent";
import DocsUploadComponent from "../../components/2.1/docs/DocsUploadComponent";
import ContractListComponent from "../../components/2.1/project/contract/ContractListComponent";
import ContractFormComponent from "../../components/2.1/project/contract/ContractFormComponent";
import ContractShowComponent from "../../components/2.1/project/contract/ContractShowComponent";
import ProjectstockListComponent from '../../components/2.1/project/projectstock/ProjectstockListComponent';
import TechnologyListComponent from "../../components/2.1/project/technology/TechnologyListComponent";
import TechnologyFormComponent from "../../components/2.1/project/technology/TechnologyFormComponent";
import ProjectitemFormComponent from "../../components/2.1/project/projectitem/ProjectitemFormComponent";
import ProjectDashboardComponent from "../../components/2.1/project/ProjectDashboardComponent";
import MaterialListComponent from '../../components/2.1/inventory/material/MaterialListComponent';
import OfferShowComponent from "../../components/2.1/project/offer/OfferShowComponent";
import FinanceListComponent from '../../components/2.1/project/finance/FinanceListComponent';
import ReceiptFormComponent from "../../components/2.1/finance/receipt/ReceiptFormComponent";
import ReceiptListComponent from "../../components/2.1/finance/receipt/ReceiptListComponent";
import ProjectPurchaseorderSupplieritemListComponent from '../../components/2.1/project/projectpurchaseorder/ProjectPurchaseorderSupplieritemListComponent';
// import ProjectPurchaseorderTableComponent from '../../components/2.1/project/projectpurchaseorder/ProjectPurchaseorderTableComponent';
import ReceiptRelationFulfillmentListComponent from '../../components/2.1/finance/receipt/ReceiptRelationFulfillmentListComponent';
import TechnologyShowComponent from '../../components/2.1/project/technology/TechnologyShowComponent';
import WorkflowListComponent from "../../components/2.1/project/workflow/WorkflowListComponent";
import WorkflowFormComponent from "../../components/2.1/project/workflow/WorkflowFormComponent";
import InventorydocumentListComponent from "../../components/2.1/inventory/inventorydocument/InventorydocumentListComponent";
import ProjectitemstatusListComponent from "../../components/2.1/project/projectitemstatus/ProjectitemstatusListComponent";
import ProjectitemstatusFormComponent from "../../components/2.1/project/projectitemstatus/ProjectitemstatusFormComponent";
import CustomerOrderProjectListComponent from "../../components/2.1/project/CustomerOrderProjectListComponent";


export const ProjectPage = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [projectTypes, setProjectTypes] = useState([]);
  const [projectSchemas, setProjectSchemas] = useState([]);
  const [offerTypes, setOfferTypes] = useState([]);
  const [projectDashboardId, setProjectDashboardId] = useState(null);
  const [project, setProject] = useState({});
  const [proformaGroups, setProformaGroups] = useState([]);
  const [creatingProforma, setCreatingProforma] = useState(false);
  const [proformaDialogVisible, setProformaDialogVisible] = useState(false);
  const [selectedProformaGroup, setSelectedProformaGroup] = useState(null);
  const [proformaCalculationMode, setProformaCalculationMode] = useState('PERCENTAGE');
  const [proformaValue, setProformaValue] = useState(null);
  const proformaValueInputRef = useRef(null);
  const [contract, setContract] = useState({});
  const [technology, setTechnology] = useState({});
  const [offer, setOffer] = useState({});
  const location = useLocation();
  const [offerStatusOptions, setOfferStatusOptions] = useState([]);
  const [loadingOfferStatus, setLoadingOfferStatus] = useState(false);
  const offerStatus = String(offer?.status || '').toUpperCase();
  const canEditOffer = !['CLOSED', 'DELETED'].includes(offerStatus);
  const isAccepted = offerStatus === 'ACCEPTED';
  // const urlParams = new URLSearchParams(history.location.search);
  // const isReceiptUpdate = urlParams.get('update') === 'receipt';
  const [localSidebarVisible, setLocalSidebarVisible] = useState(false);
  const [offerStatusDict, setOfferStatusDict] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createProjectDialogVisible, setCreateProjectDialogVisible] = useState(false);
  const [copyItemsToProject, setCopyItemsToProject] = useState(true);
  const [sentDialogVisible, setSentDialogVisible] = useState(false);
  const [pendingOfferStatus, setPendingOfferStatus] = useState(null);
  const [sentAt, setSentAt] = useState(new Date());
  const [externalId, setExternalId] = useState('');
  const [offerItemOptions, setOfferItemOptions] = useState([]);
  const [selectedOfferItemIds, setSelectedOfferItemIds] = useState([]);
  const [loadingOfferItems, setLoadingOfferItems] = useState(false);
  const [customerOrderDialogVisible, setCustomerOrderDialogVisible] = useState(false);
  const [customerOrderData, setCustomerOrderData] = useState({external_number: '', order_date: new Date(), delivery_date: null, note: ''});

  const [detailedSearchVisible, setDetailedSearchVisible] = useState(false);
  const [detailedSearchActive, setDetailedSearchActive] = useState(false);
  const [selectedProjectStockItems, setSelectedProjectStockItems] = useState([]);
  const projectStockAddHandlerRef = useRef(null);
  const roles = localStorage.getItem('roles') || '[]';
  const canWriteFulfillment = hasRole('ROLE_FULFILLMENT_WRITE');
  const hasInventoryAccess = Boolean(localStorage.getItem('module_inventory')) &&
    roles.includes('role_inventory_read');
  const hasProcurementAccess = Boolean(localStorage.getItem('module_procurement')) &&
    roles.includes('role_purchase_order_read');

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const openProformaDialog = (group) => {
    setSelectedProformaGroup(group);
    setProformaCalculationMode(isContinuousFulfillmentProject || !hasProjectValue ? 'AMOUNT' : 'PERCENTAGE');
    proformaValueInputRef.current = null;
    setProformaValue(null);
    setProformaDialogVisible(true);
  };

  const getCurrentProformaValue = () => {
    return proformaValueInputRef.current;
  };

  const createProjectProforma = () => {
    const receiptGroupId = selectedProformaGroup?.id;
    const submittedValue = getCurrentProformaValue();
    const submittedValueInvalid = !submittedValue || submittedValue <= 0 ||
      (proformaCalculationMode === 'PERCENTAGE'
        ? (projectValue <= 0 || (!isContinuousFulfillmentProject && submittedValue > 100))
        : (!isContinuousFulfillmentProject && submittedValue > projectValue));
    if (!id || !receiptGroupId || creatingProforma || submittedValueInvalid) return;
    setCreatingProforma(true);
    apiCall('post', `/api/v2/project/${id}/create-proforma/${receiptGroupId}`, {
      calculation_mode: proformaCalculationMode,
      value: submittedValue
    })
      .then(response => {
        const receiptId = response?.data?.data?.id;
        if (!receiptId) throw new Error(t('proformaCreationFailed'));
        setProformaDialogVisible(false);
        history.push(`/project/project/read/${id}?update=receipt&receiptId=${receiptId}&receiptgroupId=${receiptGroupId}`);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => setCreatingProforma(false));
  };

  const projectValue = Number(project?.net_amount ?? 0);
  const hasProjectValue = canUseProformaPercentage(project);
  const isContinuousFulfillmentProject = project?.project_type?.continuous_fulfillment === true;
  const proformaValueInvalid = !proformaValue || proformaValue <= 0 ||
    (proformaCalculationMode === 'PERCENTAGE'
      ? (projectValue <= 0 || (!isContinuousFulfillmentProject && proformaValue > 100))
      : (!isContinuousFulfillmentProject && proformaValue > projectValue));

  const patchOfferStatus = (payload) => {
    if (!id || id === 'undefined') return;
    setLoadingOfferStatus(true);
    apiCall('patch', '/api/v2/offer/' + id, payload)
      .then(response => {
        window.App.toastShow('success', 'Sikeres módosítás', response.data.message);
        setOffer(response.data.data || {});
        window.App.setState({rerenderOfferList: Math.random(), rerenderOfferShow: Math.random(),});
        setSentDialogVisible(false);
        setPendingOfferStatus(null);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoadingOfferStatus(false);
      });
  };

  const changeOfferStatus = (statusValue) => {
    if (!id || id === 'undefined') return;
    if (statusValue === 'SENT') {
      setPendingOfferStatus(statusValue);
      setSentAt(new Date());
      setSentDialogVisible(true);
      return;
    }
    patchOfferStatus({ status: statusValue });
  };

  const submitSentStatus = () => {
    if (!pendingOfferStatus || !sentAt) {
      window.App.toastShow('error', 'Hiba', 'A dátum és időpont megadása kötelező.');
      return;
    }
    patchOfferStatus({
      status: pendingOfferStatus,
      sent_at: moment(sentAt).format('YYYY-MM-DD HH:mm:ss')
    });
  };

  const getOfferStatusLabel = (statusKey) => {
    const hit = Array.isArray(offerStatusDict)
      ? offerStatusDict.find(item => item.key === statusKey)
      : null;

    return hit?.value || statusKey;
  };

  const selectedOfferProjectType = projectTypes.find(type => Number(type.id) === Number(offer?.project_type?.id || offer?.projectType?.id || offer?.project_type));
  const showExternalIdOnCreateProject =
    selectedOfferProjectType?.value_external_id &&
    selectedOfferProjectType.value_external_id !== 'disabled';

  // const downloadOffer = (offerRow) => {
  //   const offerId = offerRow?.id || id;
  //   const offerName = offerRow?.name || offer?.name || 'Ajánlat';
  //   if (!offerId || offerId === 'undefined') return;
  //   setLoadingOfferStatus(true);
  //   apiCall(
  //     'get', '/api/v2/document-category?search[related_entity][operator]=%3D&search[related_entity][value]=App\\Entity\\NewEraOffer'
  //   )
  //     .then(res => {
  //       const cat = res?.data?.data?.items?.[0];
  //       if (!cat?.id) throw new Error('Nem található.');
  //       return apiCall('post', '/api/v2/document/generate-from-offer/' + offerId, {
  //         document_category: cat.id,
  //         name: offerRow?.offer_number || offer?.offer_number || offerName,
  //         related_entity_id: offerId,
  //       });
  //     })
  //     .then(res => {
  //       const docId = res?.data?.data?.id;
  //       return axios.get(
  //         process.env.REACT_APP_API_HOST + "/api/v2/document/" + docId + "/download/pdf",
  //         {
  //           responseType: 'blob',
  //           params: {},
  //           headers: {
  //             'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
  //             'App-Network': localStorage.getItem("networkId")
  //           }
  //         }
  //       );
  //     })
  //     .then(res => {
  //       download(res.data, offerName + '.pdf');
  //     })
  //     .catch(error => {
  //       window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //     })
  //     .finally(() => {
  //       setLoadingOfferStatus(false);
  //     });
  // };
  const downloadOffer = async (offerRow, format, locale = null) => {
    const offerId = offerRow?.id || id;
    if (!offerId || offerId === 'undefined') return;
    setLoadingOfferStatus(true);
    try {
      const offerName = offerRow?.offer_number || offer?.offer_number || offer?.name || 'Ajánlat';
      const res = await axios.get(
        process.env.REACT_APP_API_HOST + `/api/v2/offer/${offerId}/download/${format}`,
        {
          responseType: 'blob',
          params: locale ? { locale } : {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        }
      );
      download(res.data, offerName + (locale ? '_' + locale : '') + '.' + format);
    } catch (error) {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    } finally {
      setLoadingOfferStatus(false);
    }
  };

  const loadOfferItemsForCreateProject = () => {
    if (!id || id === 'undefined') return;
    setLoadingOfferItems(true);
    apiCall('get', '/api/v2/offer-item/' + id + '/by-offer-and-schema')
      .then(response => {
        const schemaGroups = response?.data?.data || [];
        const options = [];
        schemaGroups.forEach(schemaGroup => {
          (schemaGroup?.items || []).forEach(item => {
            const projectItemName = item?.projectItem?.name || item?.project_item?.name || item?.name || '-';
            const projectItemId = item?.id;

            if (projectItemId) {
              options.push({
                label: projectItemName,
                value: projectItemId
              });
            }
          });
        });
        setOfferItemOptions(options);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setOfferItemOptions([]);
      })
      .finally(() => {
        setLoadingOfferItems(false);
      });
  };

  const createProjectFromOffer = () => {
    if (!id || id === 'undefined') return;
    setLoading(true);
    const payload = {
      copy_all_items: copyItemsToProject
    };
    if (!copyItemsToProject && selectedOfferItemIds.length > 0) {
      payload.items = selectedOfferItemIds;
    }
    if (showExternalIdOnCreateProject) {
      payload.external_id = externalId;
    }
    apiCall('post', `/api/v2/offer/${id}/create-project`, payload)
      .then(response => {
        window.App.toastShow('success', 'Sikeres létrehozás', response.data.message);
        setCreateProjectDialogVisible(false);

        const projectId = response?.data?.data?.id || response?.data?.data?.project?.id;
        if (projectId) {
          history.push(`/project/project/read/${projectId}`);
        } else {
          history.push('/project');
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const createCustomerOrderFromOffer = () => {
    if (!id || id === 'undefined') return;
    setLoading(true);
    apiCall('post', `/api/v2/offer/${id}/customer-order`, {
      external_number: customerOrderData.external_number || null,
      order_date: moment(customerOrderData.order_date).format('YYYY-MM-DD'),
      delivery_date: customerOrderData.delivery_date ? moment(customerOrderData.delivery_date).format('YYYY-MM-DD') : null,
      note: customerOrderData.note || null,
    }).then(response => {
      setCustomerOrderDialogVisible(false);
      window.App.toastShow('success', t('toastSaveSuccess'));
      history.push(`/sales/customer-order/read/${response.data.data.id}`);
    }).catch(error => {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    }).finally(() => setLoading(false));
  };

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/offer-status')
      .then(response => {
        setOfferStatusDict(response.data.data || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    const vars = window.App.urlVars();
    if (vars.update === 'receipt' && vars.receiptId) {
      setLocalSidebarVisible(true);
    } else {
      setLocalSidebarVisible(false);
    }
  }, [window.location.hash]);

  useEffect(() => {
    const urlVars = window.App.urlVars();
    if (urlVars.update === 'receipt' && urlVars.receiptId) {
      window.App.setState({
        props: { 
          id: Number(urlVars.receiptId), 
          receiptgroupId: Number(urlVars.receiptgroupId) 
        },
        sidebarReceiptUpdate: true
      });
    }
  }, [action, entity]);

  useEffect(() => {
    if (entity !== 'project' || !id) {
      setProformaGroups([]);
      return;
    }

    apiCall('get', '/api/v2/receipt-group?search[receipt_type][operator]==&search[receipt_type][value]=CUSTOMER_PROFORMA&search[external][operator]==&search[external][value]=false')
      .then(response => setProformaGroups(response?.data?.data?.items || []))
      .catch(error => {
        setProformaGroups([]);
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, [entity, id]);

  useEffect(() => {
    document.title = 'Projekt' + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('project')[0]) {
        document.getElementsByClassName('project')[0].classList.add("activeMenu")
      }
    }, 1000)
    apiCall('get', '/api/v2/project-type?search[active][operator]==&search[active][value]=true&item_per_page=9999')
      .then(response => {
        setProjectTypes(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/project-type?search[active][operator]==&search[active][value]=true&search[value_partner][operator]==&search[value_partner][value]=mandatory&item_per_page=9999')
      .then(response => {
        setOfferTypes(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/project-item-schema?item_per_page=9999')
      .then(response => {
        setProjectSchemas(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })


  }, [window.App.state.rerenderProjectPage]);

  useEffect(() => {
    // if ((entity === 'project' || entity === 'fulfilment' || entity === 'milestone') && id && id !== 'undefined') {
    if ((entity === 'fulfilment' || entity === 'milestone') && id && id !== 'undefined') {
      apiCall('get', '/api/v2/project/' + id)
        .then(response => {
          const dId = response?.data?.data?.dashboard_id ?? response?.data?.data?.dashboard?.id ?? null;
          setProjectDashboardId(dId);
        })
        .catch(() => {
          setProjectDashboardId(null);
        })
    }
  }, [entity, id, window.App.state.rerenderProjectShow])

  useEffect(() => {
    if (!offer?.status || (offer.status === 'ACCEPTED' && offer.project)) {
      setOfferStatusOptions([]);
      return;
    }
    apiCall('get', '/api/v2/dictionary/offer-status-transitions')
      .then(response => {
        const current = offer.status;
        const transitions = response?.data?.data?.[current] || [];
        setOfferStatusOptions(transitions);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setOfferStatusOptions([]);
      });
  }, [offer?.status, offer?.project]);

  useEffect(() => {
    if (entity === 'offer' && action === 'read' && id && id !== 'undefined') {
      apiCall('get', '/api/v2/offer/' + id)
        .then(res => {
          setOffer(res.data.data || {});
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        });
    }
  }, [entity, action, id, location.search, window.App.state.rerenderOfferShow]);

  return (
    <div className={"ProjectPage"}>
      <Dialog
        visible={proformaDialogVisible}
        header={t('proformaAmountTitle')}
        modal
        style={{width: '520px', maxWidth: '95vw'}}
        onHide={() => !creatingProforma && setProformaDialogVisible(false)}
        footer={(
          <div>
            <Button
              type="button"
              label={t('cancel')}
              className="p-button-text"
              disabled={creatingProforma}
              onClick={() => setProformaDialogVisible(false)}
            />
            <Button
              type="button"
              label={t('createProforma')}
              icon="pi pi-check"
              className="p-button-success"
              loading={creatingProforma}
              disabled={creatingProforma}
              onClick={createProjectProforma}
            />
          </div>
        )}
      >
        <div className="p-fluid">
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="proforma-percentage"
              name="proformaCalculationMode"
              value="PERCENTAGE"
              disabled={!hasProjectValue}
              checked={proformaCalculationMode === 'PERCENTAGE'}
              onChange={event => {
                setProformaCalculationMode(event.value);
                proformaValueInputRef.current = null;
                setProformaValue(null);
              }}
            />
            <label htmlFor="proforma-percentage">{t('proformaPercentageMode')}</label>
          </div>
          {!hasProjectValue && <small className="p-d-block p-mb-3">{t('proformaPercentageUnavailable')}</small>}
          <div className="p-field-radiobutton">
            <RadioButton
              inputId="proforma-amount"
              name="proformaCalculationMode"
              value="AMOUNT"
              checked={proformaCalculationMode === 'AMOUNT'}
              onChange={event => {
                setProformaCalculationMode(event.value);
                proformaValueInputRef.current = null;
                setProformaValue(null);
              }}
            />
            <label htmlFor="proforma-amount">{t('proformaAmountMode')}</label>
          </div>
          <div className="p-field p-mt-4">
            <label htmlFor="proforma-value">
              {proformaCalculationMode === 'PERCENTAGE' ? t('proformaPercentage') : t('proformaAmount')}
            </label>
            <InputNumber
              inputId="proforma-value"
              value={proformaValue}
              min={0}
              max={isContinuousFulfillmentProject
                ? undefined
                : (proformaCalculationMode === 'PERCENTAGE' ? 100 : projectValue)}
              minFractionDigits={0}
              maxFractionDigits={2}
              suffix={proformaCalculationMode === 'PERCENTAGE' ? ' %' : ` ${project?.currency || ''}`}
              className={proformaValueInvalid && proformaValue !== null ? 'p-invalid' : ''}
              onChange={event => {
                proformaValueInputRef.current = proformaNumericValue(event);
                setProformaValue(proformaValueInputRef.current);
              }}
              onValueChange={event => {
                proformaValueInputRef.current = proformaNumericValue(event);
                setProformaValue(proformaValueInputRef.current);
              }}
            />
            <small className="p-d-block p-mt-2 p-text-secondary">
              {isContinuousFulfillmentProject
                ? t('proformaContinuousFulfillmentNoLimit')
                : (proformaCalculationMode === 'PERCENTAGE'
                  ? t('proformaPercentageLimit')
                  : `${t('proformaAmountLimit')}: ${projectValue.toLocaleString('hu-HU')} ${project?.currency || ''}`)}
            </small>
          </div>
        </div>
      </Dialog>
      {/*tmp without routing*/}
      {/* {entity === 'project-status' && localStorage.getItem('roles').toString().includes('role_project_status_read') &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <Panel>
            <ProjectstatusListComponent view="simple"/>
          </Panel>
        </div>
      } */}
      {/* {entity === 'project-item-status' && localStorage.getItem('roles').toString().includes('role_project_item_status_read') &&
        <div className={"PageContent p-p-5 p-mx-auto"}>
          <Panel>
            <ProjectitemstatusListComponent view="simple"/>
          </Panel>
        </div>
      } */}
      <Sidebar position="left" visible={window.App.state.sidebarProjectstatusCreate} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 window.App.setState({sidebarProjectstatusCreate: false})
               }}>
        <h2 className={"text-primary"}>{t('projectStatusCreate')}</h2>
        <ProjectstatusFormComponent method="post"/>
      </Sidebar>
      <Sidebar position="left" visible={window.App.state.sidebarProjectstatusUpdate} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 window.App.setState({sidebarProjectstatusUpdate: false})
               }}>
        <h2 className={"text-primary"}>{t('projectStatusUpdateTitle')}</h2>
        <ProjectstatusFormComponent method="put" initialValues={window.App.state.props}/>
      </Sidebar>
      {/* <Sidebar position="left" visible={window.App.state.sidebarProjectitemstatusCreate} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 window.App.setState({sidebarProjectitemstatusCreate: false})
               }}>
        <h2 className={"text-primary"}>{t('projectItemStatusCreate')}</h2>
        <ProjectitemstatusFormComponent method="post"/>
      </Sidebar> */}
      {/* <Sidebar position="left" visible={window.App.state.sidebarProjectitemstatusUpdate} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 window.App.setState({sidebarProjectitemstatusUpdate: false})
               }}>
        <h2 className={"text-primary"}>{t('projectItemStatusUpdateTitle')}</h2>
        <ProjectitemstatusFormComponent method="put" initialValues={window.App.state.props}/>
      </Sidebar> */}

      {localStorage.getItem('module_project') ? (
          <>
            {entity === 'dashboard' && hasRole('ROLE_PROJECT_MODULE_DASHBOARD') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <ProjectDashboardComponent dashboardId={localStorage.getItem('module_project_dashboard')} />
              </div>
            }
            {(!entity || entity === 'worksheet') && (localStorage.getItem('roles') || '[]').includes('role_project_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('projectList')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    {/*<ProjectActionbuttonsComponent/>*/}
                  </span>
                  
                  
                    <Button
                      type="button"
                      label={t('detailedSearch')}
                      icon={detailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
                      className="p-button-outlined p-mr-2"
                      onClick={() => setDetailedSearchVisible(v => !v)}
                    />
                  {(localStorage.getItem('roles') || '[]').includes('role_project_write') && (
                    <SplitButton label={t('new')}
                                 id="buttonAdd"
                                 onClick={() => {
                                   document.getElementById('buttonAdd').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                                 }}
                                 icon="pi pi-plus"
                                 className={"p-button-success p-ml-md-2"}
                                 model={(() =>
                                     projectTypes
                                       .filter(type => type.active === true)
                                       .map(type => ({
                                         label: type.name,
                                         command: () => {
                                           history.push(`/project?create=project&projectTypeId=${type.id}`);
                                         }
                                       }))
                                 )()}
                    />
                  )}
                  </div>
                </div>
                <Panel>
                  <ProjectListComponent backlink={'/project'} allProjects={!entity && !window.App.urlVars().from} 
                    view={window.App.urlVars().view} detailedSearchVisible={detailedSearchVisible}
                    onDetailedSearchVisibleChange={setDetailedSearchVisible}
                    onDetailedSearchActiveChange={setDetailedSearchActive}/>
                </Panel>
              </div>
            }
            {(entity === 'project' || entity === 'fulfilment' || entity === 'milestone') && (localStorage.getItem('roles') || '[]').includes('role_project_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {project?.project_number} - {project?.name}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      // history.push('/project')
                      history.goBack();
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <TabView className="tabview-header-icon menu" style={{backgroundColor: 'white', border: 'none'}}>
                    <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                      <div className={"p-grid"}>
                        <div className={"p-col"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {t('tabBasicData')}
                              </h3>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              {(localStorage.getItem('roles') || '[]').includes('role_project_write') && (
                                <Button icon="pi pi-pencil" className="p-button-warning p-button-sm p-ml-2"
                                        label={t('editAction')} tooltipOptions={{position: 'left'}}
                                        onClick={() => {
                                          apiCall('get', '/api/v2/project/' + id, {})
                                            .then(response => {
                                            history.push('/project/project/read/' + id + '?update=project&projectDtoId=' + response.data.data.shortcut_dto_id + '&return=/project/project/read/' + id)
                                          })
                                          .catch(error => {
                                          })
                                      }}/>
                                    )}
                            </div>
                          </div>
                          {/* <ProjectShowComponent/> */}
                          <ProjectShowComponent onLoaded={(project) => {
                            setProject(project || {});
                            const dId = project?.dashboard_id ?? project?.dashboard?.id ?? null;
                            setProjectDashboardId(dId);
                          }}/>
                        </div>
                        {(localStorage.getItem('roles') || '[]').includes('role_project_write') && (
                          <div className={"p-col-8"}>
                            <div className={"p-grid"}>
                              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                  {t('projectItem')}
                              </h3>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              <SplitButton label={t('addProjectItem')}
                                           id="buttonItemAdd"
                                           type="button"
                                           disabled={!id}
                                           onClick={() => {
                                             document.getElementById('buttonItemAdd').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                                           }}
                                           icon="pi pi-plus"
                                           className={"p-button-success p-ml-md-2"}
                                           model={projectSchemas.map(schema => {
                                             return (
                                               {
                                                 label: schema.name,
                                                 command: () => {
                                                   history.push('/project/project/read/' + id + '?create=projectItem&projectItemSchemaId=' + schema.id)
                                                 }
                                               }
                                             )
                                           })}/>
                            </div>
                          </div>
                          <ProjectitemListComponent/>
                        </div>
                        )}
                      </div>
                    </TabPanel>
                    {false && (
                    <TabPanel header={t('tabMilestones')} leftIcon="pi pi-circle-fill">
                      <MilestoneListComponent backlink={'/project/project/' + id + '/read'}/>
                    </TabPanel>
                    )}
                    {roles.includes('role_customer_order_read') && (
                      <TabPanel header={t('customerOrderList')} leftIcon="pi pi-shopping-cart">
                        <CustomerOrderProjectListComponent projectId={id}/>
                      </TabPanel>
                    )}
                    {project?.project_type?.main_contractor_fulfillment_enabled !== false && (
                      <TabPanel header={t('tabFulfilments')} leftIcon="pi pi-check-circle">
                        <div className={"p-grid"}>
                          <div className={"p-col-12"}>
                            <div className={"p-grid p-ai-center"}>
                              <div className={"p-col-6"}>
                                <h3 className={"text-primary"}>{t('clientFulfilments')}</h3>
                              </div>
                              <div className={"p-col-6 p-text-right"}>
                                <SplitButton
                                  label={t('addProforma')}
                                  icon="pi pi-plus"
                                  className="p-button-success p-button-sm p-mr-2"
                                  disabled={creatingProforma || proformaGroups.length === 0}
                                  onClick={() => openProformaDialog(proformaGroups[0])}
                                  model={proformaGroups.map(group => ({
                                    label: group.name,
                                    icon: 'pi pi-file',
                                    command: () => openProformaDialog(group)
                                  }))}
                                />
                                <Button 
                                  hidden={!canWriteFulfillment} label={t('addFulfilment')}
                                  icon="pi pi-plus" 
                                  className="p-button-success p-button-sm"
                                  onClick={() => history.push(`/project/project/read/${id}?create=fulfilment&type=MAIN_CONTRACTOR`)} 
                                />
                              </div>
                            </div>
                            <FulfilmentListComponent 
                              fulfillmentType="MAIN_CONTRACTOR" 
                              backlink={'/project/project/' + id + '/read'} 
                            />
                          </div>
                        </div>
                      </TabPanel>
                    )}
                    {project?.project_type?.subcontractor_fulfillment_enabled !== false && (
                      <TabPanel header={t('tabSubcontractors')} leftIcon="pi pi-users">
                        <div className={"p-grid"}>
                          <div className={"p-col-12"}>
                            <div className={"p-grid p-ai-center"}>
                              <div className={"p-col-6"}>
                                <h3 className={"text-primary"}>{t('subcontractorContracts')}</h3>
                              </div>
                              <div className={"p-col-6 p-text-right"}>
                                <Button 
                                  label={t('addContract')} 
                                  icon="pi pi-plus" 
                                  className="p-button-success p-button-sm"
                                  onClick={() => history.push(
                                    `/project/project/read/${id}?create=contract&contractContext=subcontractor&projectId=${id}&projectName=${encodeURIComponent(project?.name || '')}&projectTypeId=${project?.project_type?.id || project?.project_type || ''}&return=${encodeURIComponent('/project/project/read/' + id)}`
                                  )}
                                />
                              </div>
                            </div>
                            <ContractListComponent 
                              view="fulfilment"
                              fulfillmentType="SUBCONTRACTOR" 
                              backlink={'/project/project/read/' + id}
                              contractContext="subcontractor"
                              projectId={id}
                            />
                            <div className={"p-grid p-ai-center"}>
                              <div className={"p-col-6"}>
                                <h3 className={"text-primary"}>{t('subcontractorFulfilments')}</h3>
                              </div>
                              {/* <div className={"p-col-6 p-text-right"}>
                                <Button 
                                  hidden={!canWriteFulfillment} label={t('addFulfilment')}
                                  icon="pi pi-plus" 
                                  className="p-button-success p-button-sm"
                                  onClick={() => history.push(`/project/project/read/${id}?create=fulfilment&type=SUBCONTRACTOR`)} 
                                />
                              </div> */}
                            </div>
                            <FulfilmentListComponent 
                              fulfillmentType="SUBCONTRACTOR" 
                              backlink={'/project/project/' + id + '/read'} 
                            />
                          </div>
                        </div>
                      </TabPanel>
                    )}

                    {hasInventoryAccess && (
                    <TabPanel header={t('tabProjectStock')} leftIcon="pi pi-shopping-cart">
                      <div className={"p-grid"}>
                          <div className={"p-col-12"}>
                            <div className={"p-grid p-ai-center"}>
                              <div className={"p-col-12 p-text-right"}>
                                <Button 
                                  label={t('addToDeliveryNote')} 
                                  icon="pi pi-plus" 
                                  className="p-button-success p-button-sm"
                                  disabled={!selectedProjectStockItems || selectedProjectStockItems.length === 0}
                                  onClick={() => {
                                    if (projectStockAddHandlerRef.current) {
                                      projectStockAddHandlerRef.current();
                                    }
                                  }} 
                                />
                              </div>
                            </div>
                          <ProjectstockListComponent onSelectionChange={setSelectedProjectStockItems} 
                            onRegisterAddToDeliveryNoteHandler={(handler) => {
                              projectStockAddHandlerRef.current = handler;
                            }}/>
                        </div>
                      </div>
                    </TabPanel>
                    )}
                    {hasProcurementAccess && (
                    <TabPanel header={t('tabPurchases')} leftIcon="pi pi-shopping-cart">
                      <ProjectPurchaseorderSupplieritemListComponent projectId={id} />
                    </TabPanel>
                    )}
                    {/* {hasProcurementAccess && (
                    <TabPanel header={t('tabMaterialList')} leftIcon="pi pi-table">
                      <ProjectPurchaseorderTableComponent projectId={id} />
                    </TabPanel>
                    )} */}

                    {financePermissions().readAllocations && <TabPanel header={t('tabCosts')} leftIcon="pi pi-wallet">
                      <FinanceListComponent/>
                    </TabPanel>}
                    <TabPanel header={t('tabInvoices')} leftIcon="pi pi-file">
                      <ReceiptRelationFulfillmentListComponent view="project" projectId={id} />
                    </TabPanel>
                    <TabPanel header={t('tabDocuments')} leftIcon="pi pi-file">
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                          <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                            Projekt dokumentumok
                          </h3>
                        </div>
                        {(localStorage.getItem('roles') || '[]').includes('role_project_write') && (
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <Button icon="pi pi-plus" className="p-button-success p-button-sm p-ml-2"
                                    label={t('addDocumentFromTemplate')} tooltipOptions={{position: 'left'}}
                                    onClick={() => {
                                      history.push('/project/project/read/' + id + '?create=docs')
                                  }}/>
                          <Button icon="pi pi-upload" className="p-button-success p-button-sm p-ml-2"
                                  label={t('uploadDocument')} tooltipOptions={{position: 'left'}}
                                  onClick={() => {
                                    history.push('/project/project/read/' + id + '?upload=docs')
                                  }}/>
                        </div>
                        )}
                      </div>
                      <DocsListComponent/>
                    </TabPanel>
                    {hasRole('ROLE_PROJECT_DASHBOARD') && <TabPanel header={t('tabReport')} leftIcon="pi pi-chart-bar">
                        <ProjectDashboardComponent key={projectDashboardId} dashboardId={String(project?.id) === String(id) ? projectDashboardId : null} />
                    </TabPanel>}
                  </TabView>
                </Panel>
              </div>
            }
            {(entity === 'project' && (action === 'create' || action === 'update')) || (window.App.urlVars().update === 'project' || window.App.urlVars().create === 'project') &&
              <Sidebar position="left"
                       showCloseIcon={false}
                       visible={action === 'create' || action === 'update' || window.App.urlVars().update === 'project' || window.App.urlVars().create === 'project'}
                       closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                        const ret = window.App.urlVars().return;
                        history.push(ret ? decodeURIComponent(ret) : '/project');
                      }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {((id || window.App.urlVars().projectId) && (id || window.App.urlVars().projectId !== 'undefined')) ? t('projectUpdate') : t('projectCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                      <a onClick={() => {
                        const ret = window.App.urlVars().return;
                        history.push(ret ? decodeURIComponent(ret) : '/project');
                      }}
                         className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    <ProjectFormComponent/>
                  </Panel>
                </div>
              </Sidebar>
            }

            {(entity === 'projectItem' && action === 'read' || action === 'update') || (entity === 'project' && window.App.urlVars().create === 'projectItem' || window.App.urlVars().update === 'projectItem') &&
              <Sidebar position="left"
                       showCloseIcon={false}
                       visible={action === 'create' || action === 'update' || window.App.urlVars().create === 'projectItem' || window.App.urlVars().update === 'projectItem'}
                       closeOnEscape={true}
                       style={{width: '1880px'}}
                       onHide={() => {
                         if (entity === 'project') {
                           history.push('/project/project/read/' + id)
                         }
                       }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {t('projectItemData')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      <span className={"p-mr-2"}>

                      </span>
                      <a onClick={() => {
                        if (entity === 'project') {
                          history.push('/project/project/read/' + id)
                        }
                      }}
                         className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    <ProjectitemFormComponent backlink={'/project/project/read/' + id}/>
                  </Panel>
                </div>
              </Sidebar>
            }




            {entity === 'worksheet' && (action === 'create' || action === 'update') &&
              <Sidebar position="left"
                       showCloseIcon={false}
                       visible={action === 'create' || action === 'update'}
                       closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                         history.push('/project')
                       }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id && id !== 'undefined' ? t('worksheetUpdate') : t('worksheetCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                      <a onClick={() => {
                        history.push('/project')
                      }}
                         className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  {/*<Panel>// TMP 2.0*/}
                  <WorksheetFormComponent backlink={'/project'}/>
                  {/*</Panel>*/}
                </div>
              </Sidebar>
            }
            {canWriteFulfillment && (((entity === 'fulfilment') && (action === 'create' || action === 'update')) || (window.App.urlVars().update === 'fulfilment' || window.App.urlVars().create === 'fulfilment')) &&
              <Sidebar position="left"
                       showCloseIcon={false}
                       visible={action === 'create' || action === 'update' || window.App.urlVars().update === 'fulfilment' || window.App.urlVars().create === 'fulfilment'}
                       closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                         history.push('/project/project/read/' + id)
                       }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('fulfilmentUpdate') : t('fulfilmentCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                      <a onClick={() => {
                        history.push('/project/project/read/' + id)
                      }}
                         className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    <FulfilmentFormComponent backlink={'/project/project/read/' + id}/>
                  </Panel>
                </div>
              </Sidebar>
            }
            

            {entity === 'project-item-status' && (!action || action === 'update' || action === 'create') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('projectItemStatus')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                    <a onClick={() => {
                      history.push('/project/project-item-status/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addProjectItemStatus')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <ProjectitemstatusListComponent backlink={'/project/project-item-status'}/>
                </Panel>
              </div>
            }
            {entity === 'project-item-status' && (action === 'create' || action === 'update') &&
              <Sidebar position="left"
                        showCloseIcon={false}
                        visible={action === 'create' || action === 'update'}
                        closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          if (action === 'create' || action === 'update') {
                            history.push('/project/project-item-status')
                          }
                        }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('projectItemStatusUpdateTitle') : t('projectItemStatusCreateTitle')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                      <a onClick={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/project/project-item-status')
                        }
                      }}
                          className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <ProjectitemstatusFormComponent backlink={'/project/project-item-status'}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }


            {(entity === 'milestone' && action === 'read' || action === 'update') || (entity === 'project' && window.App.urlVars().create === 'milestone' || window.App.urlVars().update === 'milestone') &&
              <Sidebar position="left"
                       showCloseIcon={false}
                       visible={action === 'create' || action === 'update' || window.App.urlVars().create === 'milestone' || window.App.urlVars().update === 'milestone'}
                       closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                         if (entity === 'project') {
                           history.push('/project/project/read/' + id)
                         }
                       }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('milestoneUpdate') : t('milestoneCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                      <a onClick={() => {
                        if (entity === 'project') {
                          history.push('/project/project/read/' + id)
                        }
                      }}
                         className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    <MilestoneFormComponent backlink={'/project/project/read/' + id}/>
                  </Panel>
                </div>
              </Sidebar>
            }
            {entity === 'project-type' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_project_type_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('projectTypeList')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {(localStorage.getItem('roles') || '[]').includes('role_project_type_write') && (
                    <a onClick={() => {
                      history.push('/project/project-type/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addProjectType')}
                    </a>
                  )}
                  </div>
                </div>
                <Panel>
                  <ProjecttypeListComponent backlink={'/project/project-type'}/>
                </Panel>
              </div>
            }
            {(entity === 'project-type' && (action === 'create' || action === 'update')) &&
              <Sidebar position="left"
                       showCloseIcon={false}
                       visible={action === 'create' || action === 'update'}
                       closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                         if (action === 'create' || action === 'update') {
                           history.push('/project/project-type')
                         }
                       }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('projectTypeUpdateTitle') : t('projectTypeCreateTitle')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                      <a onClick={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/project/project-type')
                        }
                      }}
                         className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <ProjecttypeFormComponent backlink={'/project/project-type'}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }

            {entity === 'project-status' && (!action || action === 'update' || action === 'create') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('App\\Project\\Project-status')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                    <a onClick={() => {
                      history.push('/project/project-status/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addProjectStatus')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <ProjectstatusListComponent backlink={'/project/project-status'}/>
                </Panel>
              </div>
            }
            {entity === 'project-status' && (action === 'create' || action === 'update') &&
              <Sidebar position="left"
                        showCloseIcon={false}
                        visible={action === 'create' || action === 'update'}
                        closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          if (action === 'create' || action === 'update') {
                            history.push('/project/project-status')
                          }
                        }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('projectStatusUpdateTitle') : t('projectStatusCreateTitle')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                      <a onClick={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/project/project-status')
                        }
                      }}
                          className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <ProjectstatusFormComponent backlink={'/project/project-status'}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }
            {entity === 'offer' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_offer_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('offerList')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {(localStorage.getItem('roles') || '[]').includes('role_offer_write') && (
                    <SplitButton label={t('new')}
                                 id="buttonAdd"
                                 onClick={() => {
                                   document.getElementById('buttonAdd').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                                 }}
                                 icon="pi pi-plus"
                                 className={"p-button-success p-ml-md-2"}
                                 model={(() =>
                                     offerTypes
                                       .filter(type => type.active === true)
                                       .map(type => ({
                                         label: type.name + ' árajánlat',
                                         command: () => {
                                           history.push(`/project/offer/create?projectTypeId=${type.id}`);
                                         }
                                       }))
                                 )()}
                                 />
                  )}
                  </div>
                </div>
                <Panel>
                  <OfferListComponent backlink={'/project/offer'}/>
                </Panel>
              </div>
            }
            {(entity === 'offer' && action === 'read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {offer?.offer_number} - {offer?.name}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <div className="p-d-inline-flex" style={{ gap: 8 }}>
                      {isAccepted && roles.includes('role_customer_order_create') && (
                        <Button type="button" label={t('customerOrderCreateFromOffer')} icon="pi pi-shopping-cart"
                                className="p-button-success"
                                onClick={() => {
                                  setCustomerOrderData({external_number: '', order_date: new Date(), delivery_date: null, note: ''});
                                  setCustomerOrderDialogVisible(true);
                                }}/>
                      )}
                      {offer?.project?.id ? (
                        <Button
                          type="button"
                          label={t('viewProject')}
                          onClick={() => {
                            history.push(`/project/project/read/${offer.project.id}`);
                          }}
                          icon="pi pi-eye"
                          className="p-button-info p-ml-2"
                          style={{ whiteSpace: 'nowrap', width: 'auto' }}
                        />
                      ) : (
                        <Button
                          type="button"
                          label={t('addProject')}
                          disabled={!isAccepted}
                          onClick={() => {
                            if (!id || id === 'undefined') return;
                            setCopyItemsToProject(true);
                            setSelectedOfferItemIds([]);
                            setOfferItemOptions([]);
                            setExternalId('');
                            setCreateProjectDialogVisible(true);
                            loadOfferItemsForCreateProject();
                          }}
                          loading={loading}
                          icon="pi pi-reply"
                          className="p-button-info p-ml-2"
                        />
                      )}
                      {id && id !== 'undefined' && offer?.status && (
                        <SplitButton
                          label={getOfferStatusLabel(offer.status)}
                          id="buttonOfferStatus"
                          type="button"
                          loading={loadingOfferStatus}
                          disabled={!id || !canEditOffer || offerStatusOptions.length === 0}
                          onClick={() => {
                            document
                              .getElementById('buttonOfferStatus')
                              ?.getElementsByClassName('p-splitbutton-menubutton')?.[0]
                              ?.click();
                          }}
                          icon="pi pi-info-circle"
                          className="p-button-warning p-button-sm p-ml-2"
                          model={offerStatusOptions.map(st => ({
                            label: getOfferStatusLabel(st.value),
                            command: () => changeOfferStatus(st.value),
                          }))}
                        />
                      )}
                      {id && id !== 'undefined' && (
                       <>
                        <SplitButton
                          icon="pi pi-file-pdf"
                          label="PDF"
                          tooltip='PDF'
                          className="p-button-secondary p-button-sm p-ml-2"
                          loading={loadingOfferStatus}
                          onClick={() => downloadOffer({ id }, 'pdf')}
                          model={[
                            {
                              label: t('downloadHungarianVersion'),
                              icon: 'pi pi-download',
                              command: () => downloadOffer({ id }, 'pdf', 'hu')
                            },
                            {
                              label: t('downloadEnglishVersion'),
                              icon: 'pi pi-download',
                              command: () => downloadOffer({ id }, 'pdf', 'en')
                            }
                          ]}
                        />
                        <SplitButton
                          icon="pi pi-file-excel"
                          label="XLSX"
                          tooltip='XLSX'
                          className="p-button-secondary p-button-sm p-ml-2"
                          loading={loadingOfferStatus}
                          onClick={() => downloadOffer({ id }, 'xlsx')}
                          model={[
                            {
                              label: t('downloadHungarianVersion'),
                              icon: 'pi pi-download',
                              command: () => downloadOffer({ id }, 'xlsx', 'hu')
                            },
                            {
                              label: t('downloadEnglishVersion'),
                              icon: 'pi pi-download',
                              command: () => downloadOffer({ id }, 'xlsx', 'en')
                            }
                          ]}
                        />
                      </>
                      )}
                      <a
                        onClick={() => history.push('/project/offer')}
                        className={"p-button  p-button-secondary p-ml-2"}
                      >
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;{t('back')}
                      </a>
                    </div>
                  </div>
                </div>
                <Panel>
                  <TabView className="tabview-header-icon menu" style={{backgroundColor: 'white', border: 'none'}}>
                    <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                      <div className={"p-grid"}>
                        <div className={"p-col"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {t('fieldName')}
                              </h3>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              {localStorage.getItem('roles').toString().includes('role_') &&
                                <Button icon="pi pi-pencil" className="p-button-warning p-button-sm p-ml-2"
                                        label={t('editAction')} tooltipOptions={{position: 'left'}}
                                        disabled={offerStatus === 'SENT' || offerStatus === 'ACCEPTED'}
                                        onClick={() => {
                                          history.push('/project/offer/read/' + id + '?update=offer&return=/project/offer/read/' + id)
                                        }}/>
                              }
                            </div>
                          </div>
                          <OfferShowComponent onLoaded={(offer) => setOffer(offer || {})} />
                        </div>
                        <div className={"p-col-8"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {t('offerItemsTitle')}
                              </h3>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              <SplitButton label={t('offerNewItem')}
                                          id="buttonOfferItemAdd"
                                          type="button"
                                          disabled={!id || offerStatus === 'SENT' || offerStatus === 'ACCEPTED'}
                                          onClick={() => {
                                            document.getElementById('buttonOfferItemAdd')
                                              .getElementsByClassName('p-splitbutton-menubutton')[0].click()
                                          }}
                                          icon="pi pi-plus"
                                          className={"p-button-success p-ml-md-2"}
                                          model={projectSchemas.map(schema => ({
                                            label: schema.name,
                                            command: () => {
                                              history.push('/project/offer/read/' + id + '?create=offerItem&offerItemSchemaId=' + schema.id)
                                            }
                                          }))}/>
                            </div>
                          </div>
                          <OfferitemListComponent/>
                        </div>
                      </div>
                    </TabPanel>
                  </TabView>
                </Panel>
              </div>
            }
            {(entity === 'offer' && (action === 'create' || action === 'update' || window.App.urlVars().update === 'offer' || window.App.urlVars().create === 'offer')) &&
              <Sidebar position="left"
                       showCloseIcon={false}
                       visible={action === 'create' || action === 'update' || window.App.urlVars().update === 'offer' || window.App.urlVars().create === 'offer'}
                       closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                         const ret = window.App.urlVars().return;
                         history.push(ret ? decodeURIComponent(ret) : '/project/offer');
                       }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('offerUpdate') : t('offerCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                      <a onClick={() => {
                        const ret = window.App.urlVars().return;
                        history.push(ret ? decodeURIComponent(ret) : '/project/offer');
                      }}
                         className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update' || window.App.urlVars().update === 'offer' || window.App.urlVars().create === 'offer') &&
                      <>
                        <OfferFormComponent backlink={'/project/offer'}/>
                      </>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }
            {(entity === 'offer' && (window.App.urlVars().create === 'offerItem' || window.App.urlVars().update === 'offerItem')) &&
              <Sidebar position="left"
                      showCloseIcon={false}
                      visible={window.App.urlVars().create === 'offerItem' || window.App.urlVars().update === 'offerItem'}
                      closeOnEscape={true}
                      style={{width: '1880px'}}
                      onHide={() => {
                        history.push('/project/offer/read/' + id)
                      }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {window.App.urlVars().create === 'offerItem' ? t('offerNewItem') : 'Árajánlat tétel adatai'}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      <a onClick={() => {
                        const ret = window.App.urlVars().return;
                        history.push(ret ? decodeURIComponent(ret) : '/project/offer/read/' + id);
                      }}
                        className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>&nbsp;{t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    <OfferitemFormComponent backlink={'/project/offer/read/' + id}/>
                  </Panel>
                </div>
              </Sidebar>
            }
            {((entity === 'docs' && (action === 'create' || action === 'update'))
              || (entity === 'project' && (window.App.urlVars().create === 'docs' || window.App.urlVars().update === 'docs'))
              || (entity === 'contract' && (window.App.urlVars().create === 'docs' || window.App.urlVars().update === 'docs'))) &&
              <Sidebar position="left"
                       showCloseIcon={false}
                       visible={action === 'create' || action === 'update'
                         || window.App.urlVars().create === 'docs' || window.App.urlVars().update === 'docs'}
                       closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                         if (action === 'create' || action === 'update') {
                           history.push('/project/docs')
                         }
                         if (entity === 'employee') {
                           history.push('/project/project/read/' + id)
                         }
                       }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {t('fromDocumentTemplate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                      <a onClick={() => {
                        if (entity === 'docs' && (action === 'create' || action === 'update')) {
                          history.push('/project/docs')
                        }
                        if (entity === 'project') {
                          history.push('/project/project/read/' + id)
                        }
                        if (entity === 'contract') {
                          history.push('/project/contract/read/' + id)
                        }
                      }}
                         className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <DocsFormComponent backlink={'/project/docs'}/>
                    }
                    {entity === 'project' &&
                      <DocsFormComponent backlink={'/project/project/read/' + id}/>
                    }
                    {entity === 'contract' &&
                      <DocsFormComponent backlink={'/project/contract/read/' + id}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }
            {((entity === 'docs' && (action === 'create' || action === 'update'))
              || (entity === 'project' && window.App.urlVars().upload === 'docs')
              || (entity === 'contract' && window.App.urlVars().upload === 'docs')) &&
              <Sidebar position="left"
                       showCloseIcon={false}
                       visible={action === 'create' || action === 'update' || window.App.urlVars().upload === 'docs'}
                       closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                         if (action === 'create' || action === 'update') {
                           history.push('/project/docs')
                         }
                         if (entity === 'employee') {
                           history.push('/project/project/read/' + id)
                         }
                       }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {t('documentUpload')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                      <a onClick={() => {
                        if (entity === 'docs' && (action === 'create' || action === 'update')) {
                          history.push('/project/docs')
                        }
                        if (entity === 'project') {
                          history.push('/project/project/read/' + id)
                        }
                        if (entity === 'contract') {
                          history.push('/project/contract/read/' + id)
                        }
                      }}
                         className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <DocsUploadComponent backlink={'/project/docs'}/>
                    }
                    {entity === 'project' &&
                      <DocsUploadComponent backlink={'/project/project/read/' + id}/>
                    }
                    {entity === 'contract' &&
                      <DocsUploadComponent backlink={'/project/contract/read/' + id}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }
            {entity === 'contract' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_project_contract_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('contractList')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {(localStorage.getItem('roles') || '[]').includes('role_project_contract_write') && (
                    <a onClick={() => {
                      history.push('/project/contract/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addContract')}
                    </a>
                  )}
                  </div>
                </div>
                <Panel>
                  <ContractListComponent backlink={'/project/contract'}/>
                </Panel>
              </div>
            }
            {(
              (entity === 'contract' && (action === 'create' || action === 'update')) ||
              window.App.urlVars().create === 'contract' ||
              window.App.urlVars().update === 'contract'
            ) &&
              <Sidebar position="left"
                      showCloseIcon={false}
                      visible={
                        action === 'create' ||
                        action === 'update' ||
                        window.App.urlVars().create === 'contract' ||
                        window.App.urlVars().update === 'contract'
                      }
                      closeOnEscape={true}
                      style={{width: '780px'}}
                      onHide={() => {
                        const ret = window.App.urlVars().return;
                        history.push(ret ? decodeURIComponent(ret) : '/project/contract');
                      }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {t('contractCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      <a onClick={() => {
                        const ret = window.App.urlVars().return;
                        history.push(ret ? decodeURIComponent(ret) : '/project/contract');
                      }}
                        className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    <ContractFormComponent
                      backlink={
                        window.App.urlVars().return
                          ? decodeURIComponent(window.App.urlVars().return)
                          : '/project/contract'
                      }
                      view={window.App.urlVars().contractContext}
                      context={window.App.urlVars().contractContext}
                      projectId={window.App.urlVars().projectId}
                      projectName={window.App.urlVars().projectName}
                      projectTypeId={window.App.urlVars().projectTypeId}
                    />
                  </Panel>
                </div>
              </Sidebar>
            }
            {window.App.urlVars().read === 'contract' && window.App.urlVars().contractId &&
              <Sidebar
                position="left"
                showCloseIcon={false}
                visible={window.App.urlVars().read === 'contract' && !!window.App.urlVars().contractId}
                closeOnEscape={true}
                style={{width: '1180px'}}
                onHide={() => {
                  const ret = window.App.urlVars().return;
                  history.push(ret ? decodeURIComponent(ret) : '/project/project/read/' + id);
                }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {t('contractView')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      {(localStorage.getItem('roles') || '[]').includes('role_project_contract_write') && (
                        <Button
                          icon="pi pi-pencil"
                          className="p-button-warning p-button-sm p-ml-2"
                          label={t('editAction')}
                          onClick={() => {
                            const ret = window.App.urlVars().return || ('/project/project/read/' + id);
                            history.push(
                              '/project/project/read/' + id +
                              '?update=contract' +
                              '&contractId=' + window.App.urlVars().contractId +
                              '&contractContext=subcontractor' +
                              '&return=' + encodeURIComponent(ret)
                            );
                          }}
                        />
                      )}

                      <a
                        onClick={() => {
                          const ret = window.App.urlVars().return;
                          history.push(ret ? decodeURIComponent(ret) : '/project/project/read/' + id);
                        }}
                        className={"p-button p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>

                  <Panel>
                    <ContractShowComponent
                      id={window.App.urlVars().contractId}
                      contractId={window.App.urlVars().contractId}
                      onLoaded={(contract) => setContract(contract || {})}
                    />
                  </Panel>
                </div>
              </Sidebar>
            }

            
            {(entity === 'contract' && action === 'read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {contract?.contract_number} - {contract?.name}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      history.push('/project/contract')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <TabView className="tabview-header-icon menu" style={{backgroundColor: 'white', border: 'none'}}>
                    <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                      <div className={"p-grid"}>
                        <div className={"p-col"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {t('fieldName')}
                              </h3>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              <Button icon="pi pi-pencil" className="p-button-warning p-button-sm p-ml-2"
                                      label={t('editAction')} tooltipOptions={{position: 'left'}}
                                      onClick={() => {
                                        history.push('/project/contract/read/' + id + '?update=contract&contractId=' + id + '&return=' + encodeURIComponent('/project/contract/read/' + id))
                                      }}/>
                            </div>
                          </div>
                          <ContractShowComponent onLoaded={(contract) => setContract(contract || {})} />
                        </div>
                        <div className={"p-col-8"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {t('projects')}
                              </h3>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>

                            </div>
                          </div>
                          <ProjectListComponent contractId={id} hidePartnerColumn />
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel header={t('tabDocuments')} leftIcon="pi pi-file">
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                          <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                            {t('contractDocuments')}
                          </h3>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                          <Button icon="pi pi-plus" className="p-button-success p-button-sm p-ml-2"
                                  label={t('addDocumentFromTemplate')} tooltipOptions={{position: 'left'}}
                                  onClick={() => {
                                    history.push('/project/contract/read/' + id + '?create=docs')
                                  }}/>
                          <Button icon="pi pi-upload" className="p-button-success p-button-sm p-ml-2"
                                  label={t('uploadDocument')} tooltipOptions={{position: 'left'}}
                                  onClick={() => {
                                    history.push('/project/contract/read/' + id + '?upload=docs')
                                  }}/>
                        </div>
                      </div>
                      <DocsListComponent/>
                    </TabPanel>
                  </TabView>
                </Panel>
              </div>
            }



            {entity === 'technology' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_technology_read') &&
                        <div className={"PageContent p-p-5 p-mx-auto"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {t('technologyList')}
                              </h2>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              <span className={"p-mr-2"}>
            
                              </span>
                              {(localStorage.getItem('roles') || '[]').includes('role_technology_write') && (
                                <a onClick={() => {
                                  history.push('/project/technology/create')
                                }}
                                   className={"p-button  p-button-success p-ml-2"}>
                                  <i className={"pi pi-plus"}></i>
                                  &nbsp;
                                  {t('addTechnology')}
                                </a>
                              )}
                            </div>
                          </div>
                          <Panel>
                            <TechnologyListComponent backlink={'/project/technology'}/>
                          </Panel>
                        </div>
                      }
                      {entity === 'technology' && (action === 'create' || action === 'update') &&
                        <Sidebar position="left"
                                 showCloseIcon={false}
                                 visible={action === 'create' || action === 'update'}
                                 closeOnEscape={true}
                                 style={{width: '780px'}}
                                 onHide={() => {
                                   if (action === 'create' || action === 'update') {
                                     history.push('/project/technology')
                                   }
                                 }}>
                          <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                            <div className={"p-grid"}>
                              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                                <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                  {t('technology')} {id ? t('updateSuffix') : t('createSuffix')}
                                </h2>
                              </div>
                              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                              <span className={"p-mr-2"}>
            
                              </span>
                                <a onClick={() => {
                                  if (action === 'create' || action === 'update') {
                                    history.push('/project/technology')
                                  }
                                }}
                                   className={"p-button  p-button-secondary p-ml-2"}>
                                  <i className={"pi pi-arrow-left"}></i>
                                  &nbsp;
                                  {t('back')}
                                </a>
                              </div>
                            </div>
                            <Panel>
                              {(action === 'create' || action === 'update') &&
                                <TechnologyFormComponent backlink={'/project/technology'}/>
                              }
                            </Panel>
                          </div>
                        </Sidebar>
                      }

            {(entity === 'technology' && action === 'read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('view')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      history.push('/project/technology')
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <TabView className="tabview-header-icon menu" style={{backgroundColor: 'white', border: 'none'}}>
                    <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                      <div className={"p-grid"}>
                        <div className={"p-col"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {t('fieldName')}
                              </h3>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            {(localStorage.getItem('roles') || '[]').includes('role_technology_write') &&
                              <Button
                                icon="pi pi-pencil"
                                className="p-button-warning p-button-sm p-ml-2"
                                label={t('editAction')}
                                tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  history.push(
                                    '/project/technology/read/' + id +
                                    '?update=technology&technologyId=' + id +
                                    '&return=' + encodeURIComponent('/project/technology/read/' + id)
                                  )
                                }}
                              />
                            }
                            </div>
                          </div>
                          <TechnologyShowComponent
                            technologyId={id}
                            onLoaded={(technology) => setTechnology(technology || {})}
                          />
                        </div>
                        <div className={"p-col-8"}>
                          <div className={"p-grid"}>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                              <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                                {t('workflows')}
                              </h3>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            {(localStorage.getItem('roles') || '[]').includes('role_') && (
                              <Button
                                icon="pi pi-plus"
                                className="p-button-success p-button-sm"
                                label={t('addWorkflow')}
                                onClick={() => {
                                  history.push(
                                    '/project/technology/read/' + id +
                                    '?create=workflow&technologyId=' + id +
                                    '&return=' + encodeURIComponent('/project/technology/read/' + id)
                                  )
                                }}
                              />
                            )}
                            </div>
                          </div>
                          <WorkflowListComponent technologyId={id} hidePartnerColumn />
                        </div>
                      </div>
                    </TabPanel>
                  </TabView>
                </Panel>
              </div>
            }
            {(entity === 'workflow' || entity === 'project') && (!action || action === 'update' || action === 'create') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('workflows')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                    <a onClick={() => {
                      history.push('/project/technology/read/' + id + '/workflow/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addWorkflow')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <WorkflowListComponent backlink={'/project/technology/read/' + id + '/workflow'}/>
                </Panel>
              </div>
            }
            {((entity === 'workflow' && (action === 'create' || action === 'update')) || window.App.urlVars().create === 'workflow' || window.App.urlVars().update === 'workflow') &&
              <Sidebar
                position="left"
                showCloseIcon={false}
                visible={ (entity === 'workflow' && (action === 'create' || action === 'update')) ||
                  window.App.urlVars().create === 'workflow' ||
                  window.App.urlVars().update === 'workflow'
                }
                closeOnEscape={true}
                style={{width: '780px'}}
                onHide={() => {
                  const ret = window.App.urlVars().return;
                  history.push(ret ? decodeURIComponent(ret) : '/project/technology/read/' + id);
                }}
              >
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {(window.App.urlVars().workflowId || (entity === 'workflow' && id)) ? t('workflowUpdate') : t('workflowCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      <a
                        onClick={() => {
                          const ret = window.App.urlVars().return;
                          history.push(ret ? decodeURIComponent(ret) : '/project/technology/read/' + id);
                        }}
                        className={"p-button p-button-secondary p-ml-2"}
                      >
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    <WorkflowFormComponent
                      key={(window.App.urlVars().workflowId || 'create') + '-' + (window.App.urlVars().technologyId || id)}
                      technologyId={window.App.urlVars().technologyId || id}
                      backlink={'/project/technology/read/' + id}
                    />
                  </Panel>
                </div>
              </Sidebar>
            }

            <Sidebar
                position="bottom"
                visible={window.App.urlVars().search === 'receiptRelationReceipt'}
                closeOnEscape={true}
                style={{ width: '100%', height: '80%' }}
                onHide={() => {
                    const basePath = history.location.pathname;
                    const params = new URLSearchParams(history.location.search);
                    params.delete('search');
                    history.push(`${basePath}?${params.toString()}`);
                }}
            >
                <div className="p-grid p-mt-3">
                    <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                        <h3 className="p-m-0 p-p-0 text-primary p-d-inline">{t('fieldBrowseDocument')}</h3>
                    </div>
                </div>
                <Panel>
                    <ReceiptListComponent
                        view="search"
                        backlink={location.pathname + "?create=receiptRelation"}
                        pickParam="related_receipt"
                        projectRetentionSearchQuery="search[receipt_type][operator]=in&search[receipt_type][value][]=SUPPLIER_INVOICE&search[receipt_type][operator]=in&search[receipt_type][value][]=SUPPLIER_ADVANCE_INVOICE"
                    />
                </Panel>
            </Sidebar>

            <Sidebar
              position="bottom"
              visible={window.App.urlVars().search === 'receiptRelationInvDoc'}
              closeOnEscape={true}
              style={{ width: '100%', height: '80%' }}
              onHide={() => {
                const basePath = history.location.pathname;
                const params = new URLSearchParams(history.location.search);
                params.delete('search');
                history.push(`${basePath}?${params.toString()}`);
              }}
            >
              <div className="p-grid p-mt-3">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('deliveryNoteBrowse')}
                  </h3>
                </div>
              </div>
              <Panel>
                <InventorydocumentListComponent
                  view="search"
                  backlink={`${history.location.pathname}?${new URLSearchParams(history.location.search).toString()}`.replace(/([&?])search=[^&]+/, '')}
                  pickParam="inventory_document"
                />
              </Panel>
            </Sidebar>


            <Sidebar 
              position="left" 
              visible={localSidebarVisible} 
              appendTo={document.body}
              baseZIndex={10000}
              closeOnEscape={true}
              style={{width: '98%'}}
              onHide={() => {
                setLocalSidebarVisible(false);
                history.push(`/project/project/read/${id}`);
              }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                {localSidebarVisible && (
                  <ReceiptFormComponent 
                    method="put" 
                    initialValues={{
                      id: Number(window.App.urlVars().receiptId),
                      receiptgroupId: Number(window.App.urlVars().receiptgroupId)
                    }}
                  />
                )}
              </div>
            </Sidebar>

            <Sidebar position="bottom"
                    visible={window.App.urlVars().search === 'material'}
                    closeOnEscape={true}
                    style={{width: '100%', height: '80%'}}
                    onHide={() => {
                      const bl = window.App.urlVars().backlink;
                      history.push(bl ? decodeURIComponent(bl) : '/project');
                    }}>
              <div className={"p-grid p-mt-3"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('materialSearch')}
                  </h3>
                </div>
              </div>
              <Panel>
                <MaterialListComponent view="search" backlink={window.App.urlVars().backlink}/>
              </Panel>
            </Sidebar>


            <Sidebar position="bottom"
                     visible={window.App.urlVars().search === 'partner'}
                     closeOnEscape={true}
                     style={{width: '100%', height: '80%'}}
                     onHide={() => {
                       const backlink = window.App.urlVars().backlink || window.App.urlVars().return;
                       history.push(backlink ? decodeURIComponent(backlink) : '/project');
                     }}>
              <div className={"p-grid p-mt-3"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('partnerSearch')}
                  </h3>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>

                </div>
              </div>
              <Panel>
                <PartnerListComponent view={"search"} backlink={
                  window.App.urlVars().backlink
                    ? decodeURIComponent(window.App.urlVars().backlink)
                    : (location.pathname + location.search)
                }
                // forcedSearchQuery={entity === 'offer' ? 'search[customer][operator]==&search[customer][value]=true' : ''}/>
                forcedSearchQuery={
                  window.App.urlVars().partnerFilter === 'vendor_service'
                    ? 'search[vendor_service][operator]==&search[vendor_service][value]=true'
                    : (entity === 'offer' || window.App.urlVars().create === 'project')
                      ? 'search[customer][operator]==&search[customer][value]=true'
                      : window.App.urlVars().create === 'fulfilment' || window.App.urlVars().update === 'fulfilment'
                        ? (
                            window.App.urlVars().type === 'MAIN_CONTRACTOR'
                              ? 'search[customer][operator]==&search[customer][value]=true&search[vendor_material][operator]==&search[vendor_material][value]=true&search[vendor_service][operator]==&search[vendor_service][value]=true'
                              : window.App.urlVars().type === 'SUBCONTRACTOR'
                                ? 'search[customer][operator]==&search[customer][value]=true&search[vendor_material][operator]==&search[vendor_material][value]=true&search[vendor_service][operator]==&search[vendor_service][value]=true'
                                : ''
                          )
                        : ''
                }/>
              </Panel>
            </Sidebar>
            <Sidebar position="bottom"
                    visible={window.App.urlVars().search === 'contract'}
                    closeOnEscape={true}
                    style={{width: '100%', height: '80%'}}
                    onHide={() => {
                      const backlink = window.App.urlVars().backlink || window.App.urlVars().return;
                      history.push(backlink ? decodeURIComponent(backlink) : '/project');
                    }}>
              <div className={"p-grid p-mt-3"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('contractSearch')}
                  </h3>
                </div>
              </div>
              <Panel>
                <ContractListComponent
                  view={"search"}
                  backlink={
                    window.App.urlVars().backlink
                      ? decodeURIComponent(window.App.urlVars().backlink)
                      : (location.pathname + location.search)
                  }
                />
              </Panel>
            </Sidebar>

                

            <Sidebar
              position="bottom"
              visible={window.App.urlVars().search === 'project'}
              closeOnEscape={true}
              style={{width: '100%', height: '80%'}}
              onHide={() => {
                const basePath =
                  '/procurement/' +
                  entity + '/' +
                  action +
                  (id && id !== 'undefined' ? '/' + id : '');
  
                history.push(basePath);
              }}
            >
              <div className="p-grid p-mt-3">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('projectSearch')}
                  </h3>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                </div>
              </div>
              <Panel>
                <ProjectListComponent
                  view={"search"}
                  backlink={
                    '/project/' +
                    entity + '/' +
                    action +
                    (id && id !== 'undefined' ? '/' + id : '')
                  }
                />
              </Panel>
            </Sidebar>
            <Dialog visible={window.App.urlVars().create === 'partner'|| window.App.urlVars().createPartner === 'true'}
                    style={{width: '980px'}}
              header={t('partnerCreate')}
                    modal
                    onHide={() => {
                      const backlink = window.App.urlVars().backlink || window.App.urlVars().return;
                      const fallback = entity ? `/project/${entity}/${action || 'read'}/${id || ''}` : '/project/offer';
                      history.push(backlink ? decodeURIComponent(backlink) : fallback);
                    }}>
              <PartnerFormComponent backlink={window.App.urlVars().backlink ? decodeURIComponent(window.App.urlVars().backlink) : '/project'}/>
            </Dialog>

            <Dialog
              visible={createProjectDialogVisible}
              style={{width: '750px'}}
              header={t('projectCreate')}
              modal
              onHide={() => {
                if (!loading) {
                  setCreateProjectDialogVisible(false);
                }
              }}
            >
              <div className="p-field">
                <label htmlFor="copyItems">Ajánlat összes tétele kerüljön létrehozásra a projektben?</label>
                <div className="p-mt-2">
                  <InputSwitch
                    id="copyItems"
                    checked={copyItemsToProject}
                    onChange={(e) => setCopyItemsToProject(e.value)}
                  />
                </div>
              </div>
              {!copyItemsToProject && (
                <>
                  <br />
                  <div className="p-field">
                    <label htmlFor="offerItems">
                      Az alábbi ajánlat tételek kerüljenek létrehozásra a projektben:
                    </label>
                    <div className="p-mt-2">
                      <MultiSelect
                        id="offerItems"
                        value={selectedOfferItemIds}
                        options={offerItemOptions}
                        onChange={(e) => setSelectedOfferItemIds(e.value || [])}
                        placeholder={loadingOfferItems ? t('loading') : t('selectOfferItemsPlaceholder')}
                        display="chip"
                        filter
                        showClear
                        disabled={loadingOfferItems}
                        className="w-100"
                      />
                    </div>
                  </div>
                </>
              )}
              {showExternalIdOnCreateProject && (
                <>
                  <br />
                  <div className="p-field">
                    <label htmlFor="external_id">{t('externalReference')}</label>
                    <div className="p-mt-2">
                      <InputText
                        id="external_id"
                        value={externalId}
                        onChange={(e) => setExternalId(e.target.value)}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="p-text-right p-mt-4">
                <Button
                  type="button"
                  label={t('saveAndBack')}
                  icon="pi pi-arrow-left"
                  className="p-button-success"
                  loading={loading}
                  onClick={createProjectFromOffer}
                />
              </div>
            </Dialog>
            <Dialog visible={customerOrderDialogVisible} style={{width: '650px'}}
                    header={t('customerOrderCreateFromOffer')} modal
                    onHide={() => !loading && setCustomerOrderDialogVisible(false)}>
              <div className="p-fluid p-grid">
                <div className="p-field p-col-12"><label>{t('customerOrderExternalNumber')}</label>
                  <InputText value={customerOrderData.external_number} onChange={e => setCustomerOrderData({...customerOrderData, external_number: e.target.value})}/>
                </div>
                <div className="p-field p-col-12 p-md-6"><label>{t('customerOrderDate')}</label>
                  <Calendar showIcon dateFormat="yy-mm-dd" value={customerOrderData.order_date} onChange={e => setCustomerOrderData({...customerOrderData, order_date: e.value})}/>
                </div>
                <div className="p-field p-col-12 p-md-6"><label>{t('customerOrderDeliveryDate')}</label>
                  <Calendar showIcon dateFormat="yy-mm-dd" value={customerOrderData.delivery_date} onChange={e => setCustomerOrderData({...customerOrderData, delivery_date: e.value})}/>
                </div>
                <div className="p-field p-col-12"><label>{t('fieldNote')}</label>
                  <InputText value={customerOrderData.note} onChange={e => setCustomerOrderData({...customerOrderData, note: e.target.value})}/>
                </div>
              </div>
              <div className="p-text-right p-mt-3">
                <Button label={t('cancel')} className="p-button-secondary p-mr-2" onClick={() => setCustomerOrderDialogVisible(false)}/>
                <Button label={t('save')} icon="pi pi-save" className="p-button-success" loading={loading} onClick={createCustomerOrderFromOffer}/>
              </div>
            </Dialog>
            <Dialog
              visible={sentDialogVisible}
              style={{width: '500px'}}
              header={t('sentAt')}
              modal
              onHide={() => {
                if (!loadingOfferStatus) {
                  setSentDialogVisible(false);
                  setPendingOfferStatus(null);
                }
              }}
            >
              <div className="p-fluid">
                <div className="p-field">
                  <label htmlFor="sentAt">Dátum + időpont</label>
                  <Calendar
                    id="sentAt"
                    value={sentAt}
                    onChange={(e) => setSentAt(e.value)}
                    showTime
                    showSeconds
                    hourFormat="24"
                    showIcon
                    dateFormat="yy-mm-dd"
                    className="p-mt-2"
                  />
                </div>
              </div>

              <div className="p-text-right p-mt-4">
                <Button
                  type="button"
                  label={t('cancel')}
                  disabled={loadingOfferStatus}
                  onClick={() => {
                    setSentDialogVisible(false);
                    setPendingOfferStatus(null);
                  }}
                />
                <Button
                  type="button"
                  label={t('save')}
                  icon="pi pi-check"
                  className="p-button-success p-ml-2"
                  loading={loadingOfferStatus}
                  onClick={submitSentStatus}
                />
              </div>
            </Dialog>
          </>
        )
        :
        (
          <p className={"p-text-center p-my-5 p-py-5"}>
            <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
            <span className={"p-text-bold p-d-block "}>Ehhez a modulhoz sajnos nem rendelkezel hozzáféréssel.</span>
            Amennyiben további információra van szükséged írj emailt a {process.env.REACT_APP_DEVOPS_CONTACT} címre.
            {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
              <span className={"p-text-bold p-d-block p-mt-5"}>
                       <a className={"p-button p-button-warning"}
                          onClick={() => {
                            window.location.replace('/#/subscriptions');
                            window.App.forceUpdate()
                          }}
                       >
                         <i className={"pi pi-building"}></i>&nbsp;Előfizetői fiók áttekintése
                       </a>
                   </span>
            }
          </p>
        )
      }
    </div>
  )
}
export default withTranslation('common')(ProjectPage);
